import { render, staticRenderFns } from "./refMULocalList.vue?vue&type=template&id=35b6dc34&scoped=true"
import script from "./refMULocalList.vue?vue&type=script&lang=js"
export * from "./refMULocalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b6dc34",
  null
  
)

export default component.exports